<div class="modal-header mainColor">
	<h6 class="modal-title">{{ title }}</h6>
	<button type="button" class="close" aria-label="Close" (click)="btnDismiss()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>

<div class="modal-footer">
	<button type="button" class="btn dangerButton" (click)="btnDismiss()">{{ "globals.buttons.cancelar" | translate }}</button>
	<button type="button" class="btn acceptButton" (click)="btnClose()">{{ "globals.buttons.accept" | translate }}</button>
</div>
